import { render, staticRenderFns } from "./GyPPatrimonialesRow.vue?vue&type=template&id=b08c6f42&"
import script from "./GyPPatrimonialesRow.vue?vue&type=script&lang=js&"
export * from "./GyPPatrimonialesRow.vue?vue&type=script&lang=js&"
import style0 from "./GyPPatrimonialesRow.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VAlert,VChip,VCol,VRow,VSimpleTable})
